export const convertToDateTime = (date: Date | string = null): Date => {
  let dat: Date
  if (date == null) {
    return new Date()
  } else if (typeof date === 'string') {
    dat = new Date(date)
  } else {
    dat = date
  }

  return dat
}

export const convertToDate = (date: Date | string = null): Date => {
  const dat = convertToDateTime(date)
  dat.setHours(0, 0, 0, 0)
  return dat
}

export const formatDate = (date: Date | string): string => {
  const dat = convertToDateTime(date)

  const day = ('00' + dat.getDate()).slice(-2)
  const month = ('00' + (dat.getMonth() + 1)).slice(-2)

  return `${day}-${month}-${dat.getFullYear()}`
}

export const selectDay = (day: number): string => {
  switch (day) {
    case 1:
      return 'ma'
    case 2:
      return 'di'
    case 3:
      return 'wo'
    case 4:
      return 'do'
    case 5:
      return 'vr'
    case 6:
      return 'za'
    case 0:
      return 'zo'
    default:
      return 'Onbekend!'
  }
}

export const toLocalDate = (date: Date | string): Date => {
  const dat = convertToDateTime(date)
  const offsetMs = dat.getTimezoneOffset() * -60 * 1000
  dat.setTime(dat.getTime() + offsetMs)
  return dat
}

export const maxEndDate: Date = new Date('2099-12-31')

export const selectLongDay = (day: number): string => {
  switch (day) {
    case 1:
      return 'Maandag'
    case 2:
      return 'Dinsdag'
    case 3:
      return 'Woensdag'
    case 4:
      return 'Donderdag'
    case 5:
      return 'Vrijdag'
    case 6:
      return 'Zaterdag'
    case 0:
      return 'Zondag'
    default:
      return 'Onbekend!'
  }
}

export const comparableDate = (date: string) => {
  let dateArray: string[] = date.split('-')
  let comparableDatestring: string = dateArray[2] + dateArray[1] + dateArray[0]
  return comparableDatestring
}

export const getDaysDisplay = (displayDays: string): string => {
  const dayArray = displayDays
    .split(',')
    .map(d => +d)
    .sort((a, b) => (a === 0 ? 1 : a - b))

  if (dayArray.length === 7) {
    return 'Alle'
  } else {
    return dayArray.map(d => selectDay(d)).join(',')
  }
}

export const compareTime = (time1: string, time2: string): number => {
  if (!time1 || !time2) return 0
  const [h1, m1] = time1.split(':').map(Number)
  const [h2, m2] = time2.split(':').map(Number)
  const minutes1 = h1 * 60 + m1
  const minutes2 = h2 * 60 + m2
  return minutes1 - minutes2
}
